"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var misc_1 = require("./misc");
/**
 * Create a click event listener for an element. Because actual click events
 * may be problematic for our other observables, this observable is based off
 * of `mousedown`, `mousemove`, and `mouseup` events. Therefore, the emitted
 * value is the element's `mousedown` event, not a `click` event.
 */
exports.createClickObservable = function (_a) {
    var element = _a.element;
    var mouseDown$ = rxjs_1.fromEvent(element, 'mousedown');
    return mouseDown$.pipe(operators_1.concatMap(function (mouseDownEvent) {
        return misc_1.documentMouseUp$.pipe(operators_1.first(), operators_1.takeUntil(misc_1.documentMouseMove$.pipe(operators_1.elementAt(3))), operators_1.tap(function (e) {
            e.stopPropagation();
            e.preventDefault();
        }), operators_1.mapTo(mouseDownEvent));
    }));
};
//# sourceMappingURL=click.js.map